/**
 * Wrapper para iconos de lucide-react
 * Facilita el uso de iconos con props consistentes
 */

import * as LucideIcons from "lucide-react";
import { cn } from "../lib/utils";

export type IconName = keyof typeof LucideIcons;

export interface IconProps {
  name: IconName;
  className?: string;
  size?: number | string;
  strokeWidth?: number;
}

/**
 * Componente de icono usando lucide-react
 * 
 * @example
 * <Icon name="User" size={24} className="text-primary" />
 */
export function Icon({ name, className, size = 24, strokeWidth = 2 }: IconProps) {
  const IconComponent = LucideIcons[name] as React.ComponentType<{
    className?: string;
    size?: number | string;
    strokeWidth?: number;
  }>;

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in lucide-react`);
    return null;
  }

  return (
    <IconComponent
      className={cn(className)}
      size={size}
      strokeWidth={strokeWidth}
    />
  );
}

// Re-exportar todos los iconos de lucide-react para uso directo
export * as Icons from "lucide-react";

